import { styled } from '@linaria/react';
import PageHeader from './shared/PageHeader';
import { PageHeaderWrapper, MainContentWrapper } from '../App.styles';

const ContentArea = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

interface LayoutProps {
    children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
    return (
        <ContentArea>
            <PageHeaderWrapper>
                <PageHeader />
            </PageHeaderWrapper>
            <MainContentWrapper>{children}</MainContentWrapper>
        </ContentArea>
    );
};

export default Layout;
